import { useDispatch, useSelector } from 'react-redux';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import PerformanceCard from '../PerformanceCard';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceConcretedOperationsSourceCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import ConcretedOperationsSourceEmptyState from './concretedOperationsSourceEmptyState';
import ConcretedOperationsSourceContent from './concretedOperationsSourceContent';

export default function ConcretedOperationsSource() {
  const dispatch = useDispatch();
  const { concretedOperationsSource } = useSelector(
    (state) => state.DashboardSlice
  );
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const { loading, hasFetched, sale, rent } = concretedOperationsSource;
  const emptySale = !sale.quantity?.length && !sale.total_value_usd?.length;
  const emptyRent = !rent.quantity?.length && !rent.total_value_usd?.length;

  const showEmptyState = emptySale && emptyRent;

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceConcretedOperationsSourceCard({ query }));
    },
    [],
    { hasFetched }
  );

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="concreted-operations-source"
    >
      <PerformanceCard.Header
        handleClickTableIcon={() =>
          dispatch(
            setPerformanceModals({
              key: 'concretedOperations',
              subkey: 'isOpen',
              value: true,
            })
          )
        }
      >
        {Trans(translations, 'ConcretedOperationsSource')}
      </PerformanceCard.Header>
      {showEmptyState ? (
        <ConcretedOperationsSourceEmptyState />
      ) : (
        <ConcretedOperationsSourceContent />
      )}
    </PerformanceCard>
  );
}
